// @flow

import PageTracker from "./PageTracker";

type PropsType = {
    $element: HTMLElement,
};

class Resource {
    props: PropsType;
    $el: HTMLElement;
    href: string;

    constructor(props: PropsType) {
        this.$el = props.$element;
        this.href = this.$el.getAttribute("data-track");

        this.attachEvents();
        this.init();
    }

    attachEvents() {
        const resource = this;
        if (this.$el && this.href) {
            this.$el.addEventListener("click", event => {
                PageTracker(resource.href);
            });
        }
    }

    init() {}
}

export default Resource;
